import { FlexContainer, Box } from '@bos/ui';
import { styled } from 'styletron-react';

import { appStaticColors } from '../const/colors/appStaticColors';
import { useI18nContext } from '../locale/i18n-react';

import { AppCard } from './AppCard';
import { AppIllustration } from './AppIllustration';
import { AppText } from './AppText/AppText';

const StyledFullPageNotFound = styled('div', {
	backgroundColor: appStaticColors.pageNotFoundBackground,
	display: 'flex',
	minHeight: '100vh',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'stretch',
});

export const AppPageNotFound = () => {
	const { LL } = useI18nContext();

	const pageNotFoundTitle = LL.common.pageNotFound.title();
	const pageNotFoundDescription = LL.common.pageNotFound.description();
	const notFound = (
		<FlexContainer direction={'column'} gap={'2'} center>
			<AppIllustration name={'thumbsDown'} size={'medium'} />
			<FlexContainer direction={'column'} gap>
				<AppText align={'center'} variant={'h2'}>
					{pageNotFoundTitle}
				</AppText>
				<AppText align={'center'} variant={'b2'}>
					{pageNotFoundDescription}
				</AppText>
			</FlexContainer>
		</FlexContainer>
	);

	return (
		<StyledFullPageNotFound>
			<Box spacing={'2'}>
				<AppCard>{notFound}</AppCard>
			</Box>
		</StyledFullPageNotFound>
	);
};
